import React, { Component } from 'react';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { List, Toast, InputItem } from 'antd-mobile';
import { createBrowserHistory } from "history";
import './style.less';
import { Button } from 'antd';

const history = createBrowserHistory();
export default class ChangePSW extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fname: '',
            oldPsw: '',
            newPsw: '',
            newPsw1: ''
        }
        this.handlePassword = this.handlePassword.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangePassword1 = this.handleChangePassword1.bind(this);

    }
    componentDidMount()
    {
        let m_user;
        if (!localStorage.getItem('QUANREN_SSO_MM_USER_CACHE')) {
            services.GetUserClaims('').then(data => {
                if (data.status === 0) {
                    localStorage.setItem('QUANREN_SSO_MM_USER_CACHE', JSON.stringify(data.result));
                    m_user = JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE'));
                }
            });
        } else {
            m_user = JSON.parse(localStorage.getItem('QUANREN_SSO_MM_USER_CACHE'));
        }
        this.setState({fname:m_user.fullname});
    
    }
    cancel = () => {
        history.goBack();
    }
    verification = () => {
        if (this.state.oldPsw === '') {
            Toast.info('旧密码不能为空！', 1);
            return false;
        }
        if (this.state.newPsw === '') {
            Toast.info('新密码不能为空！', 1);
            return false;
        }
        if (this.state.newPsw === '' || this.state.newPsw.length < 6) {
            Toast.info('新密码格式错误！', 1);
            return false;
        }
        if (this.state.newPsw !== this.state.newPsw1) {
            Toast.info('密码输入不一致!', 1);
            return false;
        }

        return true;
    }
    ModifyPSW = () => {
        if (!this.verification()) {
            return false;
        }
   
        let parameter = { oldPsw:this.state.oldPsw,newPsw: this.state.newPsw};    
            
        services.EditChangePSW(parameter, '正在执行，请稍后').then(data => {
            if (data.status === 0) {
                Toast.success('密码修改成功，请重新登录', 1, () => {
                    this.props.logout();
                    });
            } else {
                Toast.offline(data.message,2);
            }
        })
    }
    handlePassword = (e) => {
        this.setState({ oldPsw: e });
    }
    handleChangePassword = (e) => {
     
        this.setState({ newPsw: e });
    }
    handleChangePassword1 = (e) => {
        this.setState({ newPsw1: e });
    }

    render() {

        return <div className="editForm">
            <CommonlyHeadMembers barname="登录密码" />

            <List renderHeader={() => !!this.state.fname ? this.state.fname :''}>

                <InputItem
                    type="password"
                    clear name="oldPsw"
                    placeholder="请输入旧密码" onChange={this.handlePassword}
                >旧密码</InputItem>
                <InputItem
                    type="password"
                    clear name="newPsw"
                    placeholder="请输入新密码" onChange={this.handleChangePassword}
                >新密码</InputItem>

                <InputItem
                    type="password"
                    clear name="newPsw1"
                    placeholder="请再次输入新密码" onChange={this.handleChangePassword1}
                >确认密码</InputItem>
                <div className="butdiv"><Button onClick={this.cancel}>取消</Button><Button className="ok" onClick={this.ModifyPSW}>确定修改</Button></div>

            </List>
        </div>;
    }
}